import React from 'react';
import { twMerge } from 'tailwind-merge';

import { formatDurationForHumans } from '../../common/utils';

interface AudioPlayerDurationProps {
    duration: number;
    className?: string;
}

const AudioDuration = ({ duration, className }: AudioPlayerDurationProps) => {
    return (
        <span className={twMerge('text-sm order-1 lg:order-2', className)}>{formatDurationForHumans(duration)}</span>
    );
};

export default AudioDuration;
